export const calculateNetStock = (item) => {
    const physical = Number(item.PhysicalStock) || 0;
    const onOrder = Number(item.OnOrder) || 0;
    const backorders = Number(item.Backorders) || 0;
    const allocated = Number(item.Allocated) || 0;

    return (physical + onOrder) - (backorders + allocated);
};

export const calculateDOI = (netStock, avgDailySales, forecastFactor = 0) => {
    if (avgDailySales <= 0) return 999; // Treat as infinite/stagnant if no sales

    // Forecast Factor increases safety stock requirement, effectively reducing visible days of inventory
    // Logic: Adjusted DOI = NetStock / (AvgDailySales * (1 + ForecastFactor))
    const adjustedSales = avgDailySales * (1 + forecastFactor);
    return Math.round(netStock / adjustedSales);
};

/**
 * חישוב DOI עם תמיכה בדריסות ידניות (Manual Override)
 * @param {number} netStock - מלאי נטו
 * @param {number} avgDailySales - מכירות יומיות ממוצעות
 * @param {number} globalFactor - מקדם גלובלי
 * @param {object} overrides - מפת הדריסות (sku -> { factor })
 * @param {string} sku - מק"ט הפריט
 * @returns {number} ימי מלאי (DOI)
 */
export const calculateDOIWithOverride = (netStock, avgDailySales, globalFactor, overrides, sku) => {
    // בדיקה אם יש דריסה לפריט הזה
    const override = overrides?.[sku];

    // אם יש דריסה, המקדם שלה מחליף את הגלובלי
    // שים לב: הדריסה היא מקדם הכפלה (1.2 = +20%), לא החלפה מוחלטת
    const effectiveFactor = override ? (override.factor - 1) : globalFactor;

    return calculateDOI(netStock, avgDailySales, effectiveFactor);
};

export const calculateABC = (item) => {
    // Simplified ABC logic based on specification: Top 20% performers = Class A
    // This usually requires the context of all items, but per item we might just store the classification if pre-calculated
    // Or if we calculate dynamically based on revenue/velocity.
    // Assuming the item object might already have velocity data or we categorize based on thresholds provided.
    // For this v4 implementation, we'll assume we pass in a classification or derive it from 'Velocity' score if available.

    if (item.Classification) return item.Classification;

    // Fallback simple logic if velocity is present
    const velocity = Number(item.Velocity) || 0;
    if (velocity > 80) return 'A';
    if (velocity > 40) return 'B';
    return 'C';
};

export const getTrafficLight = (netStock, doi) => {
    if (netStock <= 0) return 'red';
    if (netStock < 30) return 'yellow'; // Low stock threshold
    if (doi < 7) return 'red'; // Less than a week of stock
    if (doi < 30) return 'yellow';
    return 'green';
};

// Helper for formatted currency/numbers
export const formatNumber = (num) => new Intl.NumberFormat('en-US').format(num);

